// SAMURAI — Print portfolio
// Each entry becomes a card on the Prints tab; clicking opens a native-ratio
// carousel of every KV in that brand.

export const PRINTS = [
  {
    id: "woodland",
    title: "Woodland",
    aspect: "5 / 3",
    hero: "/prints/woodland-1.jpg",
    images: [
      "/prints/woodland-1.jpg",
      "/prints/woodland-2.jpg",
      "/prints/woodland-3.jpg",
      "/prints/woodland-4.jpg",
      "/prints/woodland-5.jpg",
      "/prints/woodland-6.jpg",
    ],
  },
  {
    id: "quaffine",
    title: "Quaffine",
    aspect: "5 / 3",
    hero: "/prints/quaffine-1.jpg",
    images: [
      "/prints/quaffine-1.jpg",
      "/prints/quaffine-2.jpg",
      "/prints/quaffine-3.jpg",
      "/prints/quaffine-4.jpg",
      "/prints/quaffine-5.jpg",
      "/prints/quaffine-6.jpg",
    ],
  },
  {
    id: "closeupwn",
    title: "Close-Up White Now",
    aspect: "16 / 9",
    hero: "/prints/closeupwn-2.jpg",
    images: [
      "/prints/closeupwn-1.jpg",
      "/prints/closeupwn-2.jpg",
      "/prints/closeupwn-3.jpg",
    ],
  },
];
